import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Modal,
  Button,
  Loading,
  MessageBanner,
} from '@folio/stripes/components';

const ExitConfirmationModal = ({
  isOpen,
  onConfirm,
  onCancel,
}) => {
  const [isUnlocking, setIsUnlocking] = useState(false);
  const [unlockError, setUnlockError] = useState(null);

  const handleConfirmExit = async () => {
    console.log('🚪 [ExitConfirmationModal] User confirmed exit, starting unlock process');
    setIsUnlocking(true);
    setUnlockError(null);

    try {
      // Call the unlock function passed from parent
      await onConfirm();
      console.log('✅ [ExitConfirmationModal] Unlock successful, proceeding with exit');
      // onConfirm should handle the actual navigation/exit logic
    } catch (error) {
      console.error('❌ [ExitConfirmationModal] Unlock failed:', error);
      setUnlockError(error.message || 'فشل في تحرير القفل');
      setIsUnlocking(false);
    }
  };

  const handleCancel = () => {
    console.log('↩️ [ExitConfirmationModal] User cancelled exit');
    setIsUnlocking(false);
    setUnlockError(null);
    onCancel();
  };

  const renderContent = () => {
    if (isUnlocking) {
      return (
        <div className="exit-confirmation-modal__loading">
          <Loading />
          <div className="exit-confirmation-modal__loading-message">
            <FormattedMessage
              id="ui-plugin-inventory-templates.exitConfirmation.unlocking"
              defaultMessage="جاري تحرير القفل والخروج..."
            />
          </div>
        </div>
      );
    }

    return (
      <>
        <div className="exit-confirmation-modal__message">
          <MessageBanner type="warning">
            <FormattedMessage
              id="ui-plugin-inventory-templates.exitConfirmation.message"
              defaultMessage="لديك قفل نشط على هذه التسجيلة. سيتم تحرير القفل تلقائياً عند الخروج."
            />
          </MessageBanner>

          <div className="exit-confirmation-modal__instruction">
            <FormattedMessage
              id="ui-plugin-inventory-templates.exitConfirmation.instruction"
              defaultMessage="للحصول على أفضل تجربة، يُنصح بإغلاق نموذج التحرير من خلال زر الإلغاء قبل إغلاق التاب."
            />
          </div>
        </div>

        {unlockError && (
          <div className="exit-confirmation-modal__error">
            <MessageBanner type="error">
              {unlockError}
            </MessageBanner>
          </div>
        )}

        <div className="exit-confirmation-modal__buttons">
          <Button
            buttonStyle="primary"
            onClick={handleConfirmExit}
            disabled={isUnlocking}
          >
            <FormattedMessage
              id="ui-plugin-inventory-templates.exitConfirmation.confirm"
              defaultMessage="تحرير القفل والخروج"
            />
          </Button>
          <Button
            buttonStyle="secondary"
            onClick={handleCancel}
            disabled={isUnlocking}
          >
            <FormattedMessage
              id="ui-plugin-inventory-templates.exitConfirmation.cancel"
              defaultMessage="البقاء في الصفحة"
            />
          </Button>
        </div>
      </>
    );
  };

  return (
    <Modal
      open={isOpen}
      label={
        <FormattedMessage
          id="ui-plugin-inventory-templates.exitConfirmation.title"
          defaultMessage="تأكيد الخروج مع تحرير القفل"
        />
      }
      dismissible={!isUnlocking}
      onClose={!isUnlocking ? handleCancel : undefined}
      size="small"
      className="exit-confirmation-modal"
    >
      {renderContent()}
    </Modal>
  );
};

ExitConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ExitConfirmationModal;
